<template>
  <img class="fp_mockup" :src="require(`../img/${src}`)" alt="fp_optimizer_mockup" />
</template>
<script>
export default { props: ["src"] };
</script>
<style lang="scss">
@import "../../../../../../resources/sass/_variables.scss";

.fp_mockup {
  height: 100%;
  width: 100%;
}
</style>